<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form @submit.prevent="save">
                <div class="modal-header">
                    <button type="button" class="close" @click="goBack()">×</button>
                    <h4 class="modal-title">{{ $t('deal') }}</h4>
                </div>
                <div class="modal-body">
                    <div class="modal_deal p_bottom_15" :class="{'has-error': errors['member_id']}">
                        <div class="row">

                            <!-- Consultant -->
                            <div class="col-xs-12 col-sm-4 m_bottom_15">
                                <h5 class="m-t-0"><i class="fa-fw md-headset-mic"></i> {{ $t('consultant') }}</h5>
                                <pml-select-members v-model="record.member_id" :removeFromOptions="record.follower_id" :only-active="true"></pml-select-members>
                                <span class="error" v-if="errors['member_id']">{{ errors['member_id'][0] }}</span>
                            </div>

                            <!-- Follower -->
                            <div class="col-xs-12 col-sm-4 m_bottom_15" :class="{'has-error': errors['follower_id']}">
                                <h5 class="m-t-0"><i class="fa-fw fa fa-location-arrow"></i> {{ $t('followed_by') }}</h5>
                                <pml-select-members v-model="record.follower_id" :removeFromOptions="record.member_id" :only-active="true" :only-follow="true"></pml-select-members>
                                <span class="error" v-if="errors['follower_id']">{{ errors['follower_id'][0] }}</span>
                            </div>

                            <!-- Pipeline -->
                            <div class="col-xs-12 col-sm-4 m_bottom_15" :class="{'has-error': errors['record.pipeline_step_id']}">
                                <h5 class="m-t-0"><i class="fa-fw fa fa-toggle-right"></i> {{ $t('pipeline') }}</h5>
                                <pml-select-group v-model="record.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name" class="select_pipeline"></pml-select-group>
                                <span class="error" v-if="errors['record.pipeline_step_id']">{{ errors['record.pipeline_step_id'][0] }}</span>
                            </div>

                        </div>
                    </div>
                    <div class="modal_deal">
                        <h5 class="m-t-0"><i class="fa-fw fa fa-info-circle"></i> {{ $t('info') }}</h5>
                        <!-- Interests -->
                        <div class="row">
                            <div class="col-xs-12 m_bottom_15" :class="{'has-error': errors['interests']}">
                                <label>{{ $t('interests') }} <small class="text-muted">({{ $t('press_enter_or_tab_to_register') }})</small></label>
                                <pml-autocomplete-tag-input :url="'/deals/interests'" v-model="record.interests" :unfilteredTags="record.interests"></pml-autocomplete-tag-input>
                                <span class="error" v-if="errors['interests']">{{ errors['interests'][0] }}</span>
                            </div>
                        </div>

                        <div class="row">

                            <!-- Source -->
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['source_id']}">
                                <label>{{ $t('source') }}</label>
                                <pml-select v-model="record.source_id" :options="sources(record.source_id)"></pml-select>
                                <span class="error" v-if="errors['source_id']">{{ errors['source_id'][0] }}</span>
                            </div>

                            <!-- Segmengt -->
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['segment_id']}">
                                <label>{{ $t('segment') }}</label>
                                <pml-select v-model="record.segment_id" :options="segments(record.segment_id)"></pml-select>
                                <span class="error" v-if="errors['segment_id']">{{ errors['segment_id'][0] }}</span>
                            </div>

                        </div>

                        <!-- Message -->
                        <div class="row">
                            <div class="col-xs-12" :class="{'has-error': errors['comments']}">
                                <label>{{ $t('comments') }} <small class="text-muted">({{ $t('deal') }})</small></label>
                                <textarea class="form-control" rows="4" v-pml-autosize v-model="record.comments"></textarea>
                                <span class="error" v-if="errors['comments']">{{ errors['comments'][0] }}</span>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="p-15 clearfix">
                    <span class="btn btn-white" @click="goBack()">{{ $t('cancel') }}</span>
                    <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import RoutedModals from 'utils/mixins/routed-modals'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { update, create } from 'services/deals'
    import { mapGetters, mapActions } from 'vuex'
    import { cloneDeep, isEmpty } from 'lodash'

    export default {
        name: 'EditDealProfile',
        mixins: [ RoutedModals ],
        created () {
            if (!isEmpty(this.deal))
                this.record = cloneDeep(this.deal)
        },
        data () {
            return {
                record: {
                    member_id: null,
                    follower_id: null,
                    source_id: null,
                    segment_id: null,
                    pipeline_step_id: null,
                    interests: []
                },
                errors: [],
                isSaving: false
            }
        },
        computed: {
            ...mapGetters({
                'sources': 'getActiveSources',
                'deal': 'getDealInfo',
                'lead': 'getLeadInfo',
                'segments': 'getActiveSegments',
                'pipelines': 'getPipelines',
                'members': 'getMembers',
                'activeMembers': 'getActiveMembers'
            })
        },
        methods: {
            ...mapActions([ 'saveLeadDeal' ]),
            save () {
                return this.record.id
                    ? this.update()
                    : this.store()
            },
            store () {
                this.isSaving = true

                create({ lead_id: this.lead.id, ...this.record })
                    .then(response => {
                        this.saveLeadDeal(response.data)
                        this.goBack()
                        Notify.success(trans('the_record_has_been_saved'))
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            update () {
                this.isSaving = true

                update(this.record.id, this.record)
                    .then(response => {
                        this.goBack()
                        Notify.success(trans('the_record_has_been_saved'))
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/profile/Edit.vue